import styled from 'styled-components'

import { grayLightest, media } from '../../../../utils/style-utils'

export const TitleWrapper = styled.h3`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  padding: 0 0.5rem 0.2rem;
  align-items: flex-end;
  background: linear-gradient(180deg, transparent 0, rgba(0, 0, 0, 0.7));
  color: ${grayLightest};
  pointer-events: none;

  svg {
    pointer-events: auto;
    cursor: pointer;
  }

  ${media.sm`
    display: none;
  `}
`
